import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'util/i18n';
import { Modal } from 'components/Modal';
import { DateTime } from 'luxon';

function getServerTime(offset) {
  let displayTime = DateTime.utc().plus({ milliseconds: offset, });
  displayTime = displayTime.toISO().replace(/:\d+\.\d+/g, "");
  return displayTime;
};

// Update the clock time displayed each second
function utcClock(serverTimeDiff) {
  const [time, setTime] = useState(getServerTime(serverTimeDiff));

  useEffect(() => {
    setInterval(() => setTime(getServerTime(serverTimeDiff)), 1000);
  },
    []);

  return (
    <div>
      <p>{time}</p>
    </div>
  );
}

const SubmitConfirmationModal = function ({
  formName, submissionErred, submissionErrorCode, submissionErrorBody, submissionErrorTime, handleCancel, handleSubmit, show, serverTimeDiff
}) {
  return (
    <Modal className="submit-confirmation__modal" show={show}>
      <h3>{i18n.t('application.validForm.submit', { formName })}</h3>
      {i18n.m('application.submissionConfirmation.para', { formName })}
      {i18n.m('application.submissionConfirmation.timeNotification')}
      <div className="utc-information">
        <div className="server-time-text">
          {i18n.m('application.submissionConfirmation.serverTime')}
        </div>
        {utcClock(serverTimeDiff?.toMillis?.())}
      </div>
      {submissionErred && (
        <div className="usa-alert usa-alert-error submission-alert-error" role="alert">
          <div className="usa-alert-body">
            {i18n.m('error.submission.message', { formName })}
            {submissionErrorCode === 409
              && <>{i18n.m('error.submissionCommunication.message', { errorCode: submissionErrorCode, errorTime: submissionErrorTime.toISOString() })}</>}
            {submissionErrorBody && submissionErrorBody !== ''
              && <>{i18n.m('error.submissionErrorBody.message', { errorBody: submissionErrorBody })}</>}
            {i18n.m('error.submissionErrorCode.message', { errorCode: submissionErrorCode, errorTime: submissionErrorTime.toISOString() })}
          </div>
        </div>
      )}

      <div className="text-right">
        <button type="button" onClick={handleCancel} className="submit usa-button-secondary">
          {i18n.t('application.submissionConfirmation.back')}
        </button>
        <button type="button" onClick={handleSubmit} className="submit usa-button">
          {i18n.t('application.submissionConfirmation.submit', { formName })}
        </button>
      </div>
    </Modal>
  );
};

SubmitConfirmationModal.propTypes = {
  formName: PropTypes.string.isRequired,
  submissionErrorCode: PropTypes.number,
  submissionErrorBody: PropTypes.string,
  submissionErrorTime: PropTypes.object, // Date object
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  serverTimeDiff: PropTypes.object,
};

export default SubmitConfirmationModal;
